<template>
  <div v-if="cerfa">
    <div>
      <div class="header">
        <h3>Nature des travaux</h3>
        <b>Nota :</b> Pour connaître la délimitation du domaine public routier
        au droit d’une propriété riveraine, il faut déposer, auprès du
        gestionnaire de la route concernée et selon les modalités qu’il aura
        fixées, en complément, une demande d’alignement individuel.
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label"><b>Type(s) de travaux :</b></label>
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12" class="form-with-label">
              <ValidationProvider mode="lazy" v-slot="{ errors }" rules="required" name="type(s) de travaux">
                <b-form-checkbox-group v-model="themes" :options="natures"></b-form-checkbox-group>
                <div class="error">{{ errors[0] }}</div>
              </ValidationProvider>
            </b-col>
            <!-- WORKS a ne plus afficher
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
            </b-col>
            <b-col
              v-if="
                cerfa.themes &&
                cerfa.themes.split(',').includes('pose_compteur')
              "
              xl="10"
              lg="9"
              md="9"
              sm="12"
              cols="12"
              class="form-with-label"
            >
              <b-form-checkbox-group
                v-model="natureWork"
                :options="works"
              ></b-form-checkbox-group>
            </b-col>
            <b-col
              v-if="
                cerfa.natureWork != null && cerfa.natureWork.includes('autres')
              "
              lg="12"
              md="12"
              sm="12"
              cols="12"
              class="no-padding marginTopSmall"
              id="otherNatureWork"
            >
              <b-row class="no-margin">
                <b-col
                  xl="2"
                  lg="3"
                  md="3"
                  sm="12"
                  cols="12"
                  class="no-padding"
                >
                  <label class="control-label">Préciser</label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-form-input
                    v-model="cerfa.natureWorkOther"
                    class="form-control send-api"
                  />
                </b-col>
              </b-row>
            </b-col> -->
          </b-row>
        </div>
      </div>
    </div>
    <!-- DEPOT OU STATIONNEMENT -->
    <div v-if="cerfa.themes && cerfa.themes.split(',').includes('depot_stationnement')
      ">
      <div class="header">
        <h3>Dépôt ou stationnement</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Type de demande :</label>
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12" class="form-with-label">
              <b-form-radio-group v-model="cerfa.parkingExtension" :options="parking_extension"></b-form-radio-group>
            </b-col>
            <b-col v-if="cerfa.parkingExtension === true" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row class="no-margin">
                <b-col xl="4" lg="3" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Référence du permis de stationnement</label>
                </b-col>
                <b-col xl="8" lg="9" md="9" sm="12" cols="12">
                  <b-form-input v-model="cerfa.parkingPermit" class="form-control send-api"
                    placeholder="Référence du permis de stationnement" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label nopadding" style="text-align: left">Nature du dépôt ou stationnement</label>
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-form-checkbox-group v-model="parkingNature">
                <b-form-checkbox value="Matériaux" class="icheck send-api">
                  Matériaux</b-form-checkbox>
                <b-form-checkbox value="Benne" class="icheck send-api">
                  Benne</b-form-checkbox>
                <b-form-checkbox value="Grue" class="icheck send-api">
                  Grue</b-form-checkbox>
                <b-form-checkbox value="Etalage" class="icheck send-api">
                  Etalage</b-form-checkbox>
                <b-form-checkbox value="Echafaudage" class="icheck send-api">
                  Echafaudage</b-form-checkbox>
                <b-form-checkbox value="Mobilier urbain" class="icheck send-api">
                  Mobilier Urbain</b-form-checkbox>
                <b-form-checkbox value="Terrasses de café" class="icheck send-api">
                  Terasses de café</b-form-checkbox>
                <b-form-checkbox value="Vente le long de la voie ou aire de service" class="icheck send-api">
                  Vente le long de la voie ou sur aire de
                  service</b-form-checkbox>
                <b-form-checkbox value="Autres" class="icheck send-api">
                  Autres</b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
            <b-col v-if="cerfa.parkingNature !== null &&
              cerfa.parkingNature.includes('Autres')
              " lg="12" md="12" sm="12" cols="12" class="no-padding marginTopSmall" id="section-nature">
              <b-row class="no-margin">
                <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Préciser</label>
                </b-col>
                <b-col xl="10" lg="9" md="9" sm="12" cols="12">
                  <b-form-input v-model="cerfa.parkingNatureOther" class="form-control send-api"
                    placeholder="Préciser nature du dépôt ou stationnement" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- SAILLIE OU SURPLOMB -->
    <div v-if="cerfa.themes && cerfa.themes.split(',').includes('saillie_surplomb')
      ">
      <div class="header">
        <h3>Saillie ou surplomb</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row class="no-margin">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saillie ou surplomb : largeur de la voie ">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Largeur de la voie :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.trackWidth"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saillie ou surplomb : largeur de la saillie">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Largeur de la saillie :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.protrusionWidth"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saillie ou surplomb : largeur des trottoirs">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Largeur des trottoirs :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.sidewalkWidth"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">
                    <span v-b-tooltip.hover title="Saillie ou surplomb : hauteurs sous saillie">
                      <font-awesome-icon icon="question-circle"></font-awesome-icon>
                    </span>
                    Hauteur sous saillie :
                  </label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.heightUnderProtrusion"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- AMENAGEMENT D'ACCES -->
    <div v-if="cerfa.themes && cerfa.themes.split(',').includes('amenagement_acces')
      ">
      <div class="header">
        <h3>Aménagement d'accès</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="3" lg="3" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">Franchissement de fossé :</label>
            </b-col>
            <b-col xl="9" lg="9" md="8" sm="12" cols="12" class="form-with-label">
              <b-form-radio-group v-model="cerfa.ditchCrossing" :options="fosse"></b-form-radio-group>
            </b-col>
          </b-row>

          <b-row v-if="cerfa.ditchCrossing === true">
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Diamètre du tuyau :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.pipeDiameter" required
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="6" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Longueur :</label>
                </b-col>
                <b-col xl="4" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.pipeLength"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="8" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="6" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Distance par rapport à l'axe de la chaussée :</label>
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12">
                  <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.distanceFromRoad"
                    class="form-control send-api" />
                </b-col>
                <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <div class="control-label font-normal text-left">m</div>
                </b-col>
              </b-row>
            </b-col>
            <b-col xl="4" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-row>
                <b-col xl="6" lg="4" md="4" sm="12" cols="12" class="no-padding">
                  <label class="control-label">Nature du tuyau :</label>
                </b-col>
                <b-col xl="6" lg="4" md="4" sm="12" cols="12">
                  <b-form-input v-model="cerfa.typePipe" class="form-control send-api" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-row v-else-if="cerfa.ditchCrossing === false">
            <b-col xl="3" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <label class="control-label">Largueur de l'aménagement :</label>
            </b-col>
            <b-col xl="4" lg="4" md="4" sm="12" cols="12">
              <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.layoutWidth"
                class="form-control send-api" />
            </b-col>
            <b-col xl="5" lg="4" md="4" sm="12" cols="12" class="no-padding">
              <div class="control-label font-normal text-left">m</div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>

    <!-- OUVRAGES DIVERS -->
    <div v-if="cerfa.themes &&
      (cerfa.themes.split(',').includes('ouvrage_divers') ||
        cerfa.themes.split(',').includes('pose_compteur'))
      ">
      <div class="header">
        <h3>Ouvrages divers</h3>
      </div>
      <div class="block-content">
        <div class="form-group">
          <b-row>
            <b-col xl="2" lg="3" md="3" sm="12" cols="12" class="no-padding">
              <label class="control-label">Type d'ouvrage :</label>
            </b-col>
            <b-col xl="10" lg="9" md="9" sm="12" cols="12" class="form-with-label">
              <!-- <b-form-radio-group v-model="cerfa.newInstallation" :options="installations"></b-form-radio-group> -->
              <b-form-checkbox-group v-model="newInstallation">
                <b-form-checkbox value="false" class="icheck send-api">
                  Travaux sur ouvrages existants</b-form-checkbox>
                <b-form-checkbox value="true" class="icheck send-api">
                  Nouvelle installation</b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label" style="text-align: left">Réseaux aériens ou souterrains ou branchement
                :</label>
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-form-checkbox-group v-model="networkConnection">
                <b-form-checkbox value="eau_potable" class="icheck send-api">
                  Eau potable</b-form-checkbox>
                <b-form-checkbox value="eaux_pluviales" class="icheck send-api">
                  Eaux pluviales</b-form-checkbox>
                <b-form-checkbox value="gdf" class="icheck send-api">
                  GDF</b-form-checkbox>
                <b-form-checkbox value="operateurs_reseaux" class="icheck send-api">
                  Opérateurs réseaux</b-form-checkbox>
                <b-form-checkbox value="eaux_usees" class="icheck send-api">
                  Eaux usées</b-form-checkbox>
                <b-form-checkbox value="edf" class="icheck send-api">
                  EDF</b-form-checkbox>
                <b-form-checkbox value="autre" class="icheck send-api toggle" data-toggle="section_branchement">
                  Autres</b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
            <b-col v-if="cerfa.networkConnection !== null &&
              cerfa.networkConnection.includes('autre')
              " xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding marginTopSmall" id="section_branchement">
              <b-form-input v-model="cerfa.networkConnectionOther" class="form-control send-api" placeholder="Préciser" />
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col lg="12" md="12" sm="12" cols="12" class="no-padding">
              <table class="table-front">
                <tr>
                  <th class="no-border"></th>
                  <th>Sous voirie</th>
                  <th>Sous accotement ou trottoirs</th>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44">
                      <span v-b-tooltip.hover title="Ouvrages divers : tranchée longitudinale sous voirie / tranchée longitudinale sous accotement ou trottoirs">
                        <font-awesome-icon icon="question-circle"></font-awesome-icon>
                      </span>
                      Tranchée longitudinale
                    </label>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="10000.00"
                          v-model="cerfa.longitudinalTrenchUnderRoad" class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="10000.00"
                          v-model="cerfa.longitudinalTrenchUnderSidewalks" class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44">
                      <span v-b-tooltip.hover title="Ouvrages divers : tranchée transversale sous voirie / tranchée transversale sous accotement ou trottoirs">
                        <font-awesome-icon icon="question-circle"></font-awesome-icon>
                      </span>
                      Tranchée transversale
                    </label>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="10000.00"
                          v-model="cerfa.transverseTrenchUnderRoad" class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="10000.00"
                          v-model="cerfa.transverseTrenchUnderSidewalks" class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="control-label no-padding lh-44">
                      <span v-b-tooltip.hover title="Ouvrages divers : fonçage sous voirie / fonçage sous accotement ou trottoirs">
                        <font-awesome-icon icon="question-circle"></font-awesome-icon>
                      </span>
                      Fonçage
                    </label>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="1000.00" v-model="cerfa.drivingUnderRoad"
                          class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                  <td>
                    <b-row class="no-margin">
                      <b-col xl="9" lg="12" md="12" sm="12" cols="12">
                        <b-form-input type="number" step="0.01" min="0.00" max="1000.00"
                          v-model="cerfa.drivingUnderSidewalks" class="form-control send-api" />
                      </b-col>
                      <b-col xl="3" lg="12" md="12" sm="12" cols="12">
                        <div class="
                            text-center
                            control-label
                            font-normal
                            no-padding
                            lh-44
                          ">
                          m
                        </div>
                      </b-col>
                    </b-row>
                  </td>
                </tr>
              </table>
            </b-col>
          </b-row>
        </div>
        <div class="form-group">
          <b-row>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <label class="control-label" style="text-align: left">Aménagement de surface ou équipements</label>
            </b-col>
            <b-col xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding">
              <b-form-checkbox-group v-model="surfacePlanningEquipment">
                <b-form-checkbox value="stationnement" class="icheck send-api">
                  Stationnement</b-form-checkbox>
                <b-form-checkbox value="arret_bus" class="icheck send-api">
                  Arrêt bus</b-form-checkbox>
                <b-form-checkbox value="passage_sup_inf" class="icheck send-api">
                  Passage supérieur ou inférieur</b-form-checkbox>
                <b-form-checkbox value="equipement_route" class="icheck send-api">
                  Equipements de la route</b-form-checkbox>
                <b-form-checkbox value="autre_amenagement" class="icheck send-api">
                  Autres</b-form-checkbox>
              </b-form-checkbox-group>
            </b-col>
            <b-col v-if="cerfa.surfacePlanningEquipment !== null &&
              cerfa.surfacePlanningEquipment.includes('autre_amenagement')
              " xl="12" lg="12" md="12" sm="12" cols="12" class="no-padding marginTopSmall" id="section_amenagement">
              <b-form-input v-model="cerfa.surfacePlanningEquipmentOther" class="form-control send-api"
                placeholder="Préciser" />
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuex from "vuex";
export default {
  name: "NatureTravauxD14023",
  props: ["value"],
  methods: {
    ...Vuex.mapActions("Cerfa", ["setCerfa14023"]),
  },
  computed: {
    ...Vuex.mapGetters("Cerfa", ["cerfa14023"]),
    cerfa: {
      get: function () {
        return this.cerfa14023;
      },
      set: function (newValue) {
        this.setCerfa14023(newValue);
      },
    },
    parkingNature: {
      get() {
        if (this.cerfa.parkingNature == null) return [];
        else return this.cerfa.parkingNature.split(",");
      },
      set(value) {
        this.cerfa.parkingNature = value.join(",");
      },
    },
    themes: {
      get() {
        if (this.cerfa.themes == null) return [];
        else return this.cerfa.themes.split(",");
      },
      set(value) {
        this.cerfa.themes = value.join(",");
      },
    },
    natureWork: {
      get() {
        if (this.cerfa.natureWork == null) return [];
        else return this.cerfa.natureWork.split(",");
      },
      set(value) {
        this.cerfa.natureWork = value.join(",");
      },
    },
    surfacePlanningEquipment: {
      get() {
        if (this.cerfa.surfacePlanningEquipment == null) return [];
        else return this.cerfa.surfacePlanningEquipment.split(",");
      },
      set(value) {
        this.cerfa.surfacePlanningEquipment = value.join(",");
      },
    },
    networkConnection: {
      get() {
        if (this.cerfa.networkConnection == null) return [];
        else return this.cerfa.networkConnection.split(",");
      },
      set(value) {
        this.cerfa.networkConnection = value.join(",");
      },
    },
    newInstallation: {
      get() {
        if (this.cerfa.newInstallation == null) return [];
        else return this.cerfa.newInstallation.split(",");
      },
      set(value) {
        this.cerfa.newInstallation = value.join(",");
      },
    },
  },
  data() {
    return {
      options: [
        { text: "Oui", value: true },
        { text: "Non", value: false },
      ],
      natures: [
        //{ text: "Dépôt ou stationnement", value: "depot_stationnement" },
        { text: "Saillie ou Surplomb", value: "saillie_surplomb" },
        //{ text: "Aménagement d'accès", value: "amenagement_acces" },
        {
          text: "Pose de compteur / branchement aux réseaux",
          value: "pose_compteur",
        },
        { text: "Ouvrages divers", value: "ouvrage_divers" },
      ],
      works: [
        { text: "Station service", value: "station_service" },
        { text: "Renouvellement", value: "renouvellement" },
        { text: "Création", value: "creation" },
        { text: "Autres", value: "autres" },
      ],
      parking_extension: [
        { text: "Demande initiale", value: false },
        { text: "Prolongation", value: true },
      ],
      installations: [
        { text: "Travaux sur ouvrages existants", value: false },
        { text: "Installation nouvelle", value: true },
      ],
      fosse: [
        { text: "Avec franchissement de fossé", value: true },
        { text: "Sans franchissement de fossé", value: false },
      ],
    };
  },
};
</script>
